import angular from 'angular';
import {
  pmSharedModelService
} from 'app/services';
import {
  actionIcon,
} from 'app/components/global';
import NewSyncableSectionTitleChangeDirective from './new-syncable-section-title-change.directive';
import NewSyncableSectionTitleChangeController from './new-syncable-section-title-change.controller';
import NewSyncableSectionBodyChangeDirective from './new-syncable-section-body-change.directive';
import NewSyncableSectionBodyChangeController from './new-syncable-section-body-change.controller';
import NewSyncableEndnoteChangeDirective from './new-syncable-endnote-change.directive';
import NewSyncableEndnoteChangeController from './new-syncable-endnote-change.controller';

export default angular.module('app.components.advisory.policyManagement.syncNewRecommended', [
  actionIcon,
  pmSharedModelService,
])
  .directive('newSyncableSectionTitleChange', NewSyncableSectionTitleChangeDirective)
  .controller('NewSyncableSectionTitleChangeController', NewSyncableSectionTitleChangeController)
  .directive('newSyncableSectionBodyChange', NewSyncableSectionBodyChangeDirective)
  .controller('NewSyncableSectionBodyChangeController', NewSyncableSectionBodyChangeController)
  .directive('newSyncableEndnoteChange', NewSyncableEndnoteChangeDirective)
  .controller('NewSyncableEndnoteChangeController', NewSyncableEndnoteChangeController)
  .name;

console.log('app.components.advisory.policyManagement.syncNewRecommended');
